    export class PaginationModel  {
        total:number = 0;
        current_page:number =0;
        per_page:number = 0;
        last_page:number = 0;
        from:number = 0;
        to:number = 0;
  constructor(data) {
    Object.keys(data).map((item) => {
        if(this[item] != undefined) {
            this[item] = data[item];
        }
        });
  }      
    }